import * as Api from "@/api";
import OverflowDrawer from "@/app/shared/OverflowDrawer";
import { selectableColors } from "@/design/colors/colors";
import EditorForm from "@/design/components/EditorForm";
import SaveIndicator from "@/design/components/SaveIndicator";
import ColorPicker from "@/design/forms/ColorPicker";
import { any, string } from "@/utils/hooks/endorse";
import useSave, { SaveState } from "@/utils/hooks/useSave";

import PropTypes from "prop-types";

import ruleReducer from "./ruleReducer";

function RuleForm({ timetable, rule, timetableDispatch, setActiveRule }) {
  const { value, dispatch, setSaveState, formState, errors, allErrors, save } = useSave({
    initialValue: rule,
    reducer: ruleReducer,
    validator: () => ({
      overflow: any().required({ message: "Overflow is required." }),
      color: string().required({ message: "Color is required." }),
    }),
    onSubmit: () => Api.storeTimetableRule(timetable, value),
    onSuccess: (response) => {
      if (!value.id) {
        dispatch({ type: "id", value: response.data.rule.id });
        timetableDispatch({ type: "addRule", rule: { ...value, id: response.data.rule.id } });
        setActiveRule({ ...value, id: response.data.rule.id });
      } else {
        timetableDispatch({ type: "updateRule", rule: value });
      }
    },
  });

  const formHandler = (property, _value) => {
    dispatch({ type: property, value: _value });

    if (property === "color") {
      timetableDispatch({ type: "updateRule", rule: { ...value, [property]: _value } });
    }

    setSaveState(SaveState.UNSAVED);
  };

  return (
    <EditorForm
      title="Destination settings"
      action={<SaveIndicator formState={formState} errors={allErrors} save={save} mini />}
    >
      <OverflowDrawer
        label="Destination"
        value={value.overflow}
        propertyName="overflow"
        overflowHandler={(value) => formHandler("overflow", value)}
        filter={{ exten: [timetable.exten], custom: [], sound: [] }}
        helperText="Set a destination that should be redirected to when this destination is active."
        error={errors}
      />
      <ColorPicker
        colors={selectableColors.filter(
          (color) => !timetable.rules.find((rule) => rule.color === color[500]) || value.color === color[500],
        )}
        select={(e) => formHandler("color", e)}
        value={value.color}
        error={errors}
      />
    </EditorForm>
  );
}

RuleForm.propTypes = {
  timetable: PropTypes.object,
  rule: PropTypes.object,
  timetableDispatch: PropTypes.func,
  setActiveRule: PropTypes.func,
};

export default RuleForm;
